module.exports = __webpack_public_path__ + "static/cashew_nuts_co_mai_1-c21edfc5212ef24e70aac6ade07e4157.jpg";